<div mat-dialog-content>
  <div class="content">
    <div class="modal-body">
      <p class="white-spaced">
        {{ "SessionTimeOut.message" | translate }}
      </p>
    </div>
    <div class="filter-modal-footer">
      <button
        type="button"
        class="btn btn-lg btn-primary"
        data-dismiss="modal"
        (click)="closeSession()"
      >
        {{ "SessionTimeOut.ok" | translate }}
      </button>
    </div>
  </div>
</div>
